module.exports = __webpack_public_path__ + "img/cockroach_redchart03.3e8dd1af.jpg";